export default __webpack_public_path__ + "static/media/ASU-logo-horizontal_02.81a86590.png";